import { STREAMING_DATA_TYPES } from '@/utils/themeSettingSupport/constants';

export type ThemeQueryGenerationRequest = {
  id: number;
  request_text: string;
  generated_query: GeneratedQuery;
  deleted_keywords: Array<DeletedKeyword>;
};

export type GeneratedQuery = {
  keywords: Array<Array<Keyword>>;
  excluded_keywords: Array<ExcludedKeyword>;
  explanation: string;
  title: string;
};

export type Keyword = {
  uuid: string;
  ja: string;
  en: string;
  description?: string;
};

export type ExcludedKeyword = {
  uuid: string;
  ja: string;
  en: string;
  is_excluded_keyword: true;
};

export const isExcludedKeyword = (
  keyword?: Keyword | ExcludedKeyword,
): keyword is ExcludedKeyword => {
  return !!keyword && (keyword as ExcludedKeyword).is_excluded_keyword;
};

export type DeletedKeyword = {
  uuid: string;
  lang: 'ja' | 'en';
};

export type OpenPopupParam = {
  event: MouseEvent;
  lang: 'ja' | 'en';
  word: { uuid: string; ja: string; en: string };
  isDeletedKeyword: boolean;
};

/**
 * ストリーミングデータの型
 */
type ErrorData = {
  type: typeof STREAMING_DATA_TYPES.ERROR; // 'error'
  message: string;
};

type ResultData = {
  type: typeof STREAMING_DATA_TYPES.RESULT; // 'result'
  data: ThemeQueryGenerationRequest;
};

export type KeywordsNotExtractedResponseData = {
  type: typeof STREAMING_DATA_TYPES.KEYWORDS_NOT_EXTRACTED; // 'keywords_not_extracted'
};

export type ThemeQueryGenerationRequestResponse =
  | ErrorData
  | ResultData
  | KeywordsNotExtractedResponseData;
